module.exports = __webpack_public_path__ + "media/performance/clock-plus-a30884c8.svg";